exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.editable {\r\n    width: 100%;\r\n    min-height: 250px;\r\n    border: 1px solid #ccc;\r\n    padding: 5px;\r\n}\r\n\r\n.mat-menu-item{\r\n    height: auto;\r\n}\r\n\r\n#toolBar1 select {\r\n    font-size: 10px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/texteditor.control.css
// module id = ../../../../../client/app/shared/controls/texteditor.control.css
// module chunks = main